export const TAG_I18N_TARGET_LANGS = ['es', 'pt', 'ja', 'de']

export const TAG_I18N_LABELS = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
  ja: '日本語',
  de: 'Deutsch',
}
